import { render, staticRenderFns } from "./FeaturedMemberSingle.vue?vue&type=template&id=6edd0521&"
import script from "./FeaturedMemberSingle.vue?vue&type=script&lang=js&"
export * from "./FeaturedMemberSingle.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedMemberSingle.vue?vue&type=style&index=0&id=6edd0521&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports